<template>
  <div class="fta-header">
    <div class="title">{{ title }}</div>
    <div class="right-form">
      <div
        class="select"
        style="width: 180px"
        v-if="this.provinceSelectList.length"
      >
        <el-select
          filterable
          popper-class="select-down"
          size="small"
          v-model="provinceValue"
          placeholder="select"
          @change="handleProvinceChange"
          :popper-append-to-body="false"
        >
          <el-option
            v-for="item in provinceSelectList"
            :key="item.id"
            :label="item.val"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
      <div
        class="select"
        style="width: 180px"
        v-if="this.citySelectList.length"
      >
        <el-select
          size="small"
          filterable
          v-model="cityValue"
          placeholder="select"
          @change="handleCityChange"
          popper-class="select-down"
          :popper-append-to-body="false"
        >
          <el-option
            v-for="item in citySelectList"
            :key="item.id"
            :label="item.val"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
      <div
        class="select"
        style="width: 120px"
        v-if="this.yearSelectList.length"
      >
        <el-select
          filterable
          size="small"
          v-model="yearValue"
          placeholder="select"
          @change="handleYearChange"
          popper-class="select-down"
          :popper-append-to-body="false"
        >
          <el-option
            v-for="item in yearSelectList"
            :key="item.id"
            :label="item.val"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
      <div class="button" v-if="this.yearSelectList.length||this.provinceSelectList.length||this.citySelectList.length">
        <div @click="handleClick" class="confirm-button">Go</div>
      </div>
    </div>
  </div>
</template>

<script>
import { throttle } from '../../../ftaUtils/util'

export default {
  name: 'FtaHeader',
  props: {
    title: {
      type: String,
      default: 'title'
    },
    yearSelectList: {
      type: Array,
      default () {
        return []
      }
    },
    provinceSelectList: {
      type: Array,
      default () {
        return []
      }
    },
    citySelectList: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      yearValue: '',
      provinceValue: '',
      cityValue: ''
    }
  },
  watch: {
    yearSelectList: {
      deep: true,
      handler (newVal) {
        if (this.$route.query.year) {
          this.yearValue = this.$route.query.province
        } else if (this.yearSelectList.length) {
          this.yearValue = newVal[0].id
        }
      }
    },
    provinceSelectList: {
      deep: true,
      handler (newVal) {
        if (this.$route.query.province) {
          this.provinceValue = this.$route.query.province
        } else if (this.$route.query.provinceId) {
          this.provinceValue = this.$route.query.provinceId
        } else if (this.provinceSelectList.length) {
          this.provinceValue = newVal[0].id
        }
      }
    },
    citySelectList: {
      deep: true,
      handler (newVal) {
        if (this.$route.query.city) {
          this.cityValue = this.$route.query.city
        } else if (this.citySelectList.length) {
          this.cityValue = newVal[0].id
        }
      }
    }
  },
  methods: {
    handleYearChange (value) {
      this.yearValue = value
    },
    handleProvinceChange (value) {
      this.provinceValue = value
      this.$emit('provinceChange', value)
    },
    handleCityChange (value) {
      this.cityValue = value
      this.$emit('cityChange', value)
    },
    handleClick: throttle(function () {
      this.$emit('confirm', {
        year: this.yearValue,
        province: this.provinceValue,
        city: this.cityValue
      })
    }, 1000)
  }
}
</script>
<style src="../fta.css"  scoped></style>
<style scoped>
.fta-header {
  padding: 0 35px;
  height: 47px;
  border-bottom: 1px solid #e6e6e6;
  background: #fff;
}

.fta-header .title {
  font-size: 14px;
  color: #000000;
  letter-spacing: -0.28px;
  font-weight: 500;
  line-height: 47px;
  float: left;
}

.right-form {
  margin-top: 7px;
  float: right;
}

.right-form .select {
  margin-right: 20px;
}

.right-form .select,
.right-form .button {
  float: left;
}
</style>
